import { Shield } from 'lucide-react';

const PRIVACY_DOCS = [
  {
    title: "Privacy Statement",
    url: "https://vdskjkjxyeehklwxnhrf.supabase.co/storage/v1/object/public/docs/Privacy%20Statement%20for%20Help%20Genie.pdf",
  },
  {
    title: "Information Security Policy",
    url: "https://vdskjkjxyeehklwxnhrf.supabase.co/storage/v1/object/public/docs/Information%20Security%20Policy%20for%20Help%20Genie.pdf",
  },
  {
    title: "Internal Privacy Policy",
    url: "https://vdskjkjxyeehklwxnhrf.supabase.co/storage/v1/object/public/docs/Internal%20Privacy%20Policy%20for%20Help%20Genie.pdf",
  },
  {
    title: "Responsible AI Use Policy",
    url: "https://vdskjkjxyeehklwxnhrf.supabase.co/storage/v1/object/public/docs/Responsible%20AI%20Use%20Policy%20for%20Help%20Genie.pdf",
  },
  {
    title: "Security & Infrastructure Overview",
    url: "https://vdskjkjxyeehklwxnhrf.supabase.co/storage/v1/object/public/docs/Security%20and%20Infrastructure%20Overview%20for%20Help%20Genie.pdf",
  },
  {
    title: "Data Processing Addendum",
    url: "https://vdskjkjxyeehklwxnhrf.supabase.co/storage/v1/object/public/docs/Data%20Processing%20Addendum%20for%20Help%20Genie.pdf",
  },
  {
    title: "Identity & Access Management Policy",
    url: "https://vdskjkjxyeehklwxnhrf.supabase.co/storage/v1/object/public/docs/Identity%20and%20Access%20Management%20Policy%20for%20Help%20Genie.pdf",
  },
  {
    title: "Sub-Processor List",
    url: "https://vdskjkjxyeehklwxnhrf.supabase.co/storage/v1/object/public/docs/Sub-Processor%20List%20for%20Help%20Genie.pdf",
  },
];

export const PrivacyPoliciesSection = () => {
  return (
    <div className="bg-white rounded-[10px] p-5 shadow-[0_3px_10px_rgba(0,0,0,0.05)]">
      <div className="flex items-center mb-[18px]">
        <div className="h-8 w-8 rounded-full bg-genie-primary/10 flex items-center justify-center mr-3">
          <Shield className="h-5 w-5 text-genie-primary" />
        </div>
        <h2 className="text-xl font-semibold">Privacy & Policies</h2>
      </div>
      <div className="flex flex-col gap-3">
        {PRIVACY_DOCS.map((doc) => (
          <a
            key={doc.url}
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-genie-primary hover:underline text-sm flex items-center gap-2"
          >
            {doc.title}
            <span className="text-xs">↗</span>
          </a>
        ))}
      </div>
    </div>
  );
};
